module.exports = __webpack_public_path__ + "img/emoji_60.7f3f2d7a.png";